module.exports = __webpack_public_path__ + "img/user.436708e9.svg";